import { render, staticRenderFns } from "./DangerPdfTemplate.vue?vue&type=template&id=2b0e8872&scoped=true"
import script from "./DangerPdfTemplate.vue?vue&type=script&lang=js"
export * from "./DangerPdfTemplate.vue?vue&type=script&lang=js"
import style0 from "./DangerPdfTemplate.vue?vue&type=style&index=0&id=2b0e8872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e8872",
  null
  
)

export default component.exports